import React, { FC } from 'react';

import { Container, Image as ImageComponent, Text } from '@lglp/components';
import { MultipleCardsContainer } from '@lglp/prismic-client';

import { LinkedComponent } from '../../../LinkedComponent';
import styles from './MultipleCardsContainer.module.scss';

export const MultipleCardsContainerSlice: FC<MultipleCardsContainerProps> = ({
  data,
}) => {
  const { imageTitle, textTitle, tiles } = data;
  return (
    <Container className={[styles.container, 'not-icon-cards']}>
      {imageTitle && (
        <ImageComponent
          className={styles.imageTitle}
          src={imageTitle?.src}
          fit
        />
      )}
      {!imageTitle && textTitle && (
        <Text className={styles.textTitle} body={textTitle} />
      )}
      <Container className={styles.tilesContainer}>
        {tiles &&
          tiles.map((tile, key) => {
            const { ctaLabel, ctaLink, image } = tile;
            return (
              <LinkedComponent className={styles.card} link={ctaLink} key={key}>
                <ImageComponent className={styles.image} src={image?.src} fit />
                <Text className={styles.ctaLabel} body={ctaLabel} />
              </LinkedComponent>
            );
          })}
      </Container>
    </Container>
  );
};

type MultipleCardsContainerProps = {
  data: MultipleCardsContainer;
};
